import axios from "axios";
// Update with API
export let UpdateUser = async (jwt,userName,userEmail,userPassword,user_id,languageId) => {
    let url = process.env.REACT_APP_ADMIN_API_URL + `/users/` + user_id
  try {
    let data = "";
    
    let qs = require('qs');

    data = qs.stringify({
      'name': userName,
      'email': userEmail,
      'password': userPassword,
      'language_id': languageId
    });
    const response = await axios.put(
      url,
      data,
    {
      headers: {
          'Authorization': 'Bearer '+jwt, 
          'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    return response.data
  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};